import { Link } from "react-router-dom";
import { Eye, Lock, Sparkles, MoreVertical } from "lucide-react";
import { useRef } from "react";

const fmtViews = (n) => n >= 1e6 ? (n/1e6).toFixed(1)+"M" : n >= 1e3 ? (n/1e3).toFixed(1)+"K" : String(n);
const fmtDur = (s) => {
  if (!s) return "";
  const m = Math.floor(s/60), r = s%60;
  return `${m}:${String(r).padStart(2,'0')}`;
};

const BADGE_STYLES = {
  LIVE: { bg: "bg-[#FF3EA5]", text: "text-white" },
  NEW: { bg: "bg-[#7A5CFF]", text: "text-white" },
  HOT: { bg: "bg-[#FF6B00]", text: "text-white" },
  FEATURED: { bg: "bg-[#FF3EA5]", text: "text-white" },
};

export default function VideoCard({ v, badge }) {
  const videoRef = useRef(null);
  const onEnter = () => { const el = videoRef.current; if (el && v.video_url) { el.play().catch(()=>{}); } };
  const onLeave = () => { const el = videoRef.current; if (el) { el.pause(); el.currentTime = 0; } };
  const showBadge = badge || (v.featured ? "FEATURED" : null);
  const bStyle = showBadge ? BADGE_STYLES[showBadge] : null;

  return (
    <Link to={`/watch/${v.id}`} data-testid={`video-card-${v.id}`} className="group block"
          onMouseEnter={onEnter} onMouseLeave={onLeave}>
      <div className="relative aspect-video rounded-2xl overflow-hidden bg-[#0a0a18] border border-white/5">
        {v.thumbnail_url ? (
          <img src={v.thumbnail_url || undefined} alt={v.title} loading="lazy"
            className="w-full h-full object-cover group-hover:opacity-0 transition-opacity duration-300"/>
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-[#1a1a24] to-[#0a0a0e]"/>
        )}
        {v.video_url && (
          <video ref={videoRef} src={v.video_url || undefined} muted loop playsInline
                 className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-300"/>
        )}
        {/* Views count top-left */}
        <span className="absolute top-2 left-2 px-2 py-1 rounded-md bg-black/70 text-[11px] font-bold flex items-center gap-1"><Eye size={11}/>{fmtViews(v.views)}</span>
        {v.duration > 0 && (
          <span className="absolute top-2 right-2 px-2 py-1 rounded-md bg-black/70 text-[11px] font-bold">{fmtDur(v.duration)}</span>
        )}
        {showBadge && bStyle && (
          <span className={`absolute bottom-2 left-2 px-2 py-0.5 rounded-md text-[10px] font-extrabold tracking-wide ${bStyle.bg} ${bStyle.text}`}>{showBadge}</span>
        )}
        {v.is_promoted && (
          <span className="absolute top-9 right-2 px-2 py-0.5 rounded-full text-[10px] font-bold bg-white/15 backdrop-blur border border-white/20 inline-flex items-center gap-1"><Sparkles size={10}/>Promoted</span>
        )}
        <div className="absolute bottom-2 right-2">
          {v.is_paid ? (
            <span className="px-2 py-0.5 rounded-md text-[11px] font-extrabold bg-[#FFD700] text-black inline-flex items-center gap-1">
              <Lock size={10}/> {v.price_coins}
            </span>
          ) : (
            <span className="px-2 py-0.5 rounded-md text-[10px] font-bold bg-black/70 text-[#00E7FF] border border-[#00E7FF]/40">FREE</span>
          )}
        </div>
      </div>
      <div className="mt-3 flex gap-3 items-start">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#00E7FF] to-[#FF3EA5] flex items-center justify-center text-black font-bold text-sm shrink-0 overflow-hidden">
          {v.creator?.avatar_url ? <img src={v.creator.avatar_url} alt="" className="w-full h-full object-cover"/> : (v.creator?.username || "?")[0]?.toUpperCase()}
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="text-sm font-bold leading-snug line-clamp-2 group-hover:text-[#00E7FF] transition-colors">{v.title}</h3>
          <p className="text-xs text-white/60 mt-0.5">{v.creator?.username || "jixxeo videos"}</p>
        </div>
        <button onClick={(e)=>{e.preventDefault(); e.stopPropagation();}} className="p-1 text-white/40 hover:text-white shrink-0">
          <MoreVertical size={16}/>
        </button>
      </div>
    </Link>
  );
}
